module.exports = __webpack_public_path__ + "img/IMG017.ef38e89e.jpg";